// default TYPO3 file for standalone usage

export default class CoreMailDecrypter {

	decryptCharcode (n, start, end, offset) {
		n = n + offset;
		if (offset > 0 && n > end) {
			n = start + (n - end - 1);
		} else if (offset < 0 && n < start) {
			n = end - (start - n - 1);
		}
		return String.fromCharCode(n);
	}

	decryptString (enc, offset) {
		var dec = "";
		var len = enc.length;
		for (var i = 0; i < len; i++) {
			var n = enc.charCodeAt(i);
			if (n >= 0x2B && n <= 0x3A) {
				dec += this.decryptCharcode(n, 0x2B, 0x3A, offset);	// 0-9 . , - + / :
			} else if (n >= 0x40 && n <= 0x5A) {
				dec += this.decryptCharcode(n, 0x40, 0x5A, offset);	// A-Z @
			} else if (n >= 0x61 && n <= 0x7A) {
				dec += this.decryptCharcode(n, 0x61, 0x7A, offset);	// a-z
			} else {
				dec += enc.charAt(i);
			}
		}
		return dec;
	}

	init () {
		const mailLinkIdentifier = 'javascript:linkTo_UnCryptMailto';
		const mailLinkIdentifierRegEx = new RegExp(mailLinkIdentifier, '');
		let mailLinks = Array.prototype.filter.call(
			document.getElementsByTagName('a'),
			function (testElement) {
				return testElement.attributes.href && testElement.attributes.href.value.match(mailLinkIdentifierRegEx);
			}
		);
		let me = this;
		mailLinks.forEach(function (link) {
			link.addEventListener('click', function (evt) {
				evt.preventDefault();
				// !!! Assumes: config.spamProtectEmailAddresses = -3
				const href = decodeURIComponent(this.attributes.href.value);
				const code = '"' + href.substring("javascript:linkTo_UnCryptMailto('".length, href.length - 3) + '"';
				location.href = me.decryptString(JSON.parse(code), 3);
			});
		});
	}
};
